import React from "react";
import PropTypes from "prop-types";

const faqList = [
	{
		question: "What services do you provide?",
		answer:
			"Our main services include web development, mobile app development, custom software solutions, cloud integration, security consulting, etc.	",
	},
	{
		question: "How do you estimate project costs?",
		answer:
			"We conduct an initial consultation to understand requirements in detail, then provide a cost estimate based on factors like scope of work, timeline, technologies involved, etc.",
	},
	{
		question: "What is your development process?",
		answer:
			"We follow a structured methodology like Agile or Waterfall. It involves requirements gathering, design, development, testing, deployment and support.",
	},
	{
		question: "How long does a typical project take?",
		answer:
			"Project duration can range from a few weeks for smaller tasks to 3-6 months for complex enterprise solutions. It depends on various factors we evaluate upfront.",
	},
	{
		question: "How do you ensure data security?",
		answer:
			"We follow stringent policies and practices around encryption, authentication, authorizations and compliance to safeguard sensitive data and systems.",
	},
	{
		question: "What technologies do you specialize in?",
		answer:
			"Our expertise lies in HTML, CSS, Javascript, React JS, Node JS, Mongo DB, PHP, .NET, Java, Python, AWS, Azure, mobile platforms and various frameworks.",
	},
	{
		question: "Do you offer free consultations?",
		answer:
			"Yes, we provide free initial consultations to discuss your requirement in detail and provide recommendations without any obligations.",
	},
	
];

const FaqItem = ({ faq }) => (
	<div className="bg-gray-100 dark:bg-[#1E2735] rounded-xl">
		<h5 className="p-4 lg:p-6 lg:pb-5 w-full text-start flex justify-between items-center font-medium text-xl">
			<span>{faq.question}</span>
		</h5>
		<div className=" px-4 lg:px-6 lg:pb-6">
			<p className="opacity-50 mb-0">{faq.answer}</p>
		</div>
	</div>
);

FaqItem.propTypes = {
	faq: PropTypes.object.isRequired,
};

const FaqComponent = () => {
	return (
		<section className="py-14 md:py-24 bg-white dark:bg-[#0b1727] text-zinc-900 dark:text-white">
			<div className="container px-16 md:px-8 lg:px-28">
				<div className="grid grid-cols-12 justify-center md:mb-6">
					<div className="col-span-12 lg:col-span-8 lg:col-start-3 xl:px-12 text-center">
						<h2 className="font-bold text-[25px] md:text-[45px] leading-none mb-4">
							Frequently Asked Questions
						</h2>
					</div>
				</div>

				<div className="grid grid-cols-12 gap-6 mt-12">
					{faqList.map((faq, i) => (
						<div className="col-span-12 md:col-span-6" key={i}>
							<FaqItem faq={faq} />
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default FaqComponent;

